import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpErrorResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStateService } from '@core/services/auth/auth-state';
import { catchError, switchMap, throwError, from } from 'rxjs';

export const RestAuthInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const auth: AuthStateService = inject(AuthStateService);
  let handledReq: HttpRequest<unknown> = req;

  const token: string | undefined = auth.token();
  if (token) {
    handledReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  return next(handledReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        return from(auth.refreshTokens()).pipe(
          switchMap((ok) => {
            if (!ok) {
              auth.logout();
              return throwError(() => error);
            }

            const newToken: string | undefined = auth.token();
            if (!newToken) {
              auth.logout();
              return throwError(() => error);
            }

            const newReq: HttpRequest<unknown> = req.clone({
              headers: req.headers.set('Authorization', `Bearer ${newToken}`),
            });

            return next(newReq);
          }),
        );
      }

      return throwError(() => error);
    }),
  );
};
